import { createSlice } from "@reduxjs/toolkit";

import {
  getNegotiationThunk,
  createNegotiationThunk,
  updateNegotiationThunk,
  deleteNegotiationThunk,
} from "state/action/negotiation";

// Initial state
const initialState = {
  // Get Negotiation inisial state
  getNegotiation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Negotiation inisial state
  createNegotiation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Negotiation inisial state
  updateNegotiation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Negotiation inisial state
  deleteNegotiation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createNegotiationInputBody: {
    proposed_rental_fee: "",
    proposed_service_charge: "",
    proposed_duration: "",
    proposed_deposit: "",
    proposed_payment_method: "",
    negotiation_notes: "",
    status: "",
    proposed_by: "",
  },

  // Negotiation object value
  negotiation_object_value: "",
};

const asyncState = (overrides = {}) => ({
  data: null,
  isFulfilled: false,
  isPending: false,
  isRejected: false,
  err: null,
  ...overrides,
});

export const negotiationSlice = createSlice({
  name: "negotiation",
  initialState,
  reducers: {
    setGetNegotiationObjectValue: (state, action) => {
      return {
        ...state,
        negotiation_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetNegotiationObjectValue: (state, _) => {
      return {
        ...state,
        negotiation_object_value: "",
      };
    },
    setClearCreateNegotiationInputBody: (state, _) => {
      return {
        ...state,
        proposed_rental_fee: "",
        proposed_service_charge: "",
        proposed_duration: "",
        proposed_deposit: "",
        proposed_payment_method: "",
        negotiation_notes: "",
        status: "",
        proposed_by: "",
      };
    },
    setCreateNegotiationInputBody: (state, action) => {
      return {
        ...state,
        createNegotiationInputBody: action.payload,
      };
    },
    setClearGetNegotiation: (state, _) => {
      return {
        ...state,
        getNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateNegotiation: (state, _) => {
      return {
        ...state,
        createNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateNegotiation: (state, _) => {
      return {
        ...state,
        updateNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteNegotiation: (state, _) => {
      return {
        ...state,
        deleteNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllNegotiationState: (state, _) => {
      return {
        ...state,
        // Get Negotiation inisial state
        getNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Negotiation inisial state
        createNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Negotiation inisial state
        updateNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Negotiation inisial state
        deleteNegotiation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Negotiation object value
        negotiation_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Negotiation reducer
      .addCase(getNegotiationThunk.pending, (state, _) => {
        return {
          ...state,
          getNegotiation: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getNegotiationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getNegotiation: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getNegotiationThunk.rejected, (state, action) => {
        return {
          ...state,
          getNegotiation: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Negotiation reducer
      .addCase(createNegotiationThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createNegotiationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createNegotiationThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Negotiation reducer
      .addCase(updateNegotiationThunk.pending, (state, _) => {
        return {
          ...state,
          updateNegotiation: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateNegotiationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateNegotiation: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateNegotiationThunk.rejected, (state, action) => {
        return {
          ...state,
          updateNegotiation: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const negotiationAction = {
  ...negotiationSlice.actions,
  getNegotiationThunk,
  createNegotiationThunk,
  updateNegotiationThunk,
  deleteNegotiationThunk,
};

export function selectNegotiationObjectValue(state) {
  return state?.negotiation?.negotiation_object_value;
}

export function selectNegotiation(state) {
  return state?.negotiation;
}

export default negotiationSlice.reducer;
